<template>
<div>
  <div v-if="ticketSubmissionResult == null" class="ui form">
    <div class="field" v-show="false">
      <label>Your Contact E-Mail Address</label>
      <input type="text" v-model="contactEmail">
    </div>
    <div class="field" v-show="category !== 'new_feature'">
      <label>Summary</label>
      <input type="text" v-model="subject">
    </div>
    <div class="field">
      <label>{{label}}</label>
      <textarea v-model="ticketContent" autofocus></textarea>
    </div>
    <div class="two fields" v-show="category !== 'new_feature'">
      <div class="field">
        <label>ASIN</label>
        <input type="text" v-model="asin">
      </div>
      <div class="field">
        <label>Marketplace</label>
        <select class="ui fluid search dropdown" name="helpModalMarketplace" v-model="marketplace">
          <option value="">Marketplace</option>
          <option value="US">US</option>
          <option value="CA">CA</option>
          <option value="MX">MX</option>
          <option value="BR">BR</option>
          <option value="UK">UK</option>
          <option value="DE">DE</option>
          <option value="FR">FR</option>
          <option value="ES">ES</option>
          <option value="IT">IT</option>
          <option value="NL">NL</option>
        </select>
      </div>
    </div>
    <div class="field" v-if="productExistsError">
      <div class="ui negative message">
        <div class="header">Error</div>
        <p>{{productExistsError}}</p></div>
    </div>
    <div class="field" v-if="productExistsWarning">
      <div class="ui negative message">
        <div class="header">Warning</div>
        <p>{{productExistsWarning}}</p></div>
    </div>
    <button class="ui primary button" v-on:click="submitTicket()">Submit</button>
  </div>
  <div v-else-if="ticketSubmissionResult ===  true" style="text-align: center">
    <p style="margin-top:40px" class="ui large header">Thank You for contacting us!</p>
    <span class="ui medium header">We have received your message and we'll get back to you shortly.</span>
  </div>
  <div v-else style="text-align: center">
    <p style="margin-top:40px" class="ui medium header">Something went wrong while processing your message</p>
    <p class="ui small header">Please e-mail support@sentrykit.com</p>
  </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      subject: this.category === 'new_feature' ? 'Feature Request' : '',
      contactEmail: this.$root.userEmail,
      ticketContent: '',
      ticketSubmissionResult: null,
      asin: '',
      marketplace: '',
      productExistsWarning: '',
      productExistsError: '',
    }
  },
  props: ['category', 'label', 'lastClosedAt'],
  methods: {
    submitTicket: function () {
      this.$http.post('/api/support/ticket', {
        email: this.contactEmail,
        subject: this.subject,
        body: this.ticketContent,
        category: this.category,
        asin: this.asin,
        marketplace: this.marketplace,
      }).then((response) => {
        this.ticketSubmissionResult = true
      }, (response) => {
        this.ticketSubmissionResult = false
      })
    },
    resetState: function () {
      this.subject = ''
      this.ticketContent = ''
      this.ticketSubmissionResult = null
    },
    updateAsinExistence: function () {
      const params = {}
      if (this.marketplace) params.marketplace = this.marketplace
      const re = /^[^A-Z0-9]*([A-Z0-9]+)[^A-Z0-9]*$/
      const m = re.exec(this.asin)
      if (!m) {
        this.productExistsError = ''
        this.productExistsWarning = ''
        return
      }
      const asin = m[1]
      this.$http.get('/api/product/asin/exists/' + asin, {params: params
      }).then((response) => {
        this.productExistsError = ''
        if (response.body.trackedMarketplaces) {
          if (!params.marketplace && (response.body.trackedMarketplaces.indexOf('US') >= 0 || response.body.trackedMarketplaces.indexOf('UK') >= 0)) {
            this.productExistsWarning = ''
          } else {
            this.productExistsWarning = 'ASIN ' + asin + ' is only tracked on the following marketplace' + (response.body.trackedMarketplaces.length > 1 ? 's: ' : ': ') + response.body.trackedMarketplaces.join(', ')
          }
        } else {
          this.productExistsWarning = ''
        }
      }, (response) => {
        if (response.status === 404) {
          if (params.marketplace) {
            this.productExistsError = 'ASIN ' + asin + ' does not exist in the ' + params.marketplace + ' marketplace'
          } else {
            this.productExistsError = 'ASIN ' + asin + ' does not exist in SentryKit'
          }
        } else if (response.status === 402) {
          this.productExistsError = 'ASIN ' + asin + ' is not tracked. You may start tracking this ASIN in your Product Tracking Settings'
        } else {
          this.productExistsError = ''
        }
        this.productExistsWarning = ''
      })
    },
  },
  watch: {
    '$root.userEmail': function (val) {
      this.contactEmail = val
    },
    'lastClosedAt': function (val) {
      this.resetState()
    },
    asin: function () {
      this.updateAsinExistence()
    },
    marketplace: function () {
      this.updateAsinExistence()
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// HelpModal.SupportTicketForm.vue?7c649b11